import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { ShortsErrorDialogComponent } from '../shorts-error-dialog/shorts-error-dialog.component';

@Component({
  selector: 'app-shorts',
  templateUrl: './shorts.component.html',
  styleUrls: ['./shorts.component.css']
})
export class ShortsComponent implements OnInit {

  @HostListener('window:scroll', ['$event']) 
  doSomething(event) {
    // this.isForFirstTime = true;
    // console.debug("Scroll Event", document.body.scrollTop);
    // see András Szepesházi's comment below
  // event.stopImmediatePropagation();
    
    // window.scrollTo(window.scrollX, window.scrollY+20)
    // console.debug("Scroll Event", window.scrollTo = window.scrollY+150);
  }

  userLikeStatus: boolean = false;
  userDislikeStatus: boolean = false;
  isForFirstTime:boolean = true

  constructor(public router: Router, public dialog: MatDialog,
    public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.getPlayList();
    var timer:any;
    var lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      return;
      var st = window.pageYOffset || document.documentElement.scrollTop;
      clearTimeout(timer);
      // this.isForFirstTime = true
      // set a timer for 100 ms
      timer = setTimeout(() => {
        if(this.isForFirstTime == true){
          this.isForFirstTime = false;
          let roundTo = Math.floor(window.scrollY/650);
          if (st > lastScrollTop) {
          window.scrollBy(window.scrollX, window.scrollY+650); 
          } else if(st < lastScrollTop) {
            window.scrollBy(window.scrollX, window.scrollY-650); 
          }
          lastScrollTop = st <= 0 ? 0 : st;
        }else{
          clearTimeout(timer);
          this.isForFirstTime = true;
        }
      }, 500);
  });
}

  

  videoFullData:any;
  videoDetailsPlayList:any;
  playlists:any
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  isPlay: boolean = false;

  ngOnDestroy(){
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
      video.muted = true;
    })
  }

  playPause(vid:any) {
    //console.log(vid);
    var myVideo: any = document.getElementById("my_video_" + vid);
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  getPlayList(){
    const playListId = localStorage.getItem('selfLearnSelectedPlayList');
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    const params = {
      examId: this.selfLearnService.getCmsExamID(),
      subTenantId: this.selfLearnService.getSubtenantId(),
      playlistTypeId: playListId,
    }
    this.selfLearnService.getVideosByPlayListId(params).subscribe((resp:any) => {
      this.playlists = resp.data[0].videos;
      this.playlists.forEach((element:any) => {
        // element.videoURL = (element.videoURL).replace('https://', 'http://');
        // element.thumbnailURL = (element.thumbnailURL).replace('https://', 'http://');
     });
     const videoId = localStorage.getItem("selfLearnSelectedVideoId");
     const currentIndex = this.setPlayListIndex(videoId);
     this.swapSelectedElement(currentIndex);
     setTimeout(() => {
      this.playPauseVideo();
     }, 500);
    })
  }

  swapSelectedElement(currentIndex:any){
    var temp = this.playlists[0];
    this.playlists[0] = this.playlists[currentIndex];
    this.playlists[currentIndex] = temp;
  }

  setPlayListIndex(videoId:any){
    var indexDef = 0;
    for (let index = 0; index < this.playlists.length; index++) {
      const element = this.playlists[index];
      if(element.videoId == videoId){
        indexDef = index
      }
    }
    return indexDef;
  }

  userLike() {
    this.userLikeStatus = !this.userLikeStatus;
  }
  userDislike() {
    this.userDislikeStatus = !this.userDislikeStatus;
  }

  openErrorDialog() {
    this.dialog.open(ShortsErrorDialogComponent, { width: '375px', panelClass: ['shorts-error-modal', 'mweb-stiky-bottom'] });
  }

  navigateToPreviousPage(){
    const previousPage = localStorage.getItem("selfLearnPreviousPage");
    const navigationPath = (previousPage == 'home') ? 'selfLearn-V2' : 'selfLearn-V2/videos'
    this.router.navigateByUrl(navigationPath);
  }

  playPauseVideo() {
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        // We can only control playback without insteraction if video is mute
        // video.muted = true;
        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (
                                entry.intersectionRatio !== 1 &&
                                !video.paused
                            ) {
                                video.pause();
                                // document.getElementById('shortsActn').classList.toggle('pause');
                            } else if (video.paused) {
                                // document.getElementById('shortsActn').classList.toggle('');
                                video.play();
                            }
                        });
                    },
                    { threshold: 0.5}
                );
                observer.observe(video);
            });
        }
    });
}


  

}
